import React from "react"
import { Link } from "gatsby"

export default function StoryMeta({ post }) {
  return (
    <div className={"story-meta w-full text-base  border-dashed p-4 border-4 border-light-blue-500 mb-8"}>
      {post.storyCategorys.nodes && (
        <p className={"mb-4 md:text-left"}>
          <span className={"mr-2 font-bold"}>Categories:</span>
          {post.storyCategorys.nodes.map(item => (
            <Link
              key={`${item.slug}`}
              to={`/${item.slug}`}
              className={" mr-4"}
            >
              {item.name}
            </Link>
          ))}
        </p>
      )}
      {post.storyData.author && <p><span className={"mr-2 font-bold"}>Author:</span>{post.storyData.author}</p>}
    </div>
  )
}
